const { FORM_MODE } = require('../constants');
const { getCurrentMode } = require('../helpers');

/**
 *
 * @param {*} fieldValue
 * @param {*} validation
 * @param {object} options
 * @param {function} options.getFieldBydId function getFieldBydId (backend only)
 * @param {*} options.objectType
 * @param {*} options.pkObjectType
 * @param {*} options.fieldName
 * @param {*} options.globalModel
 * @returns
 */
const uniqueBack = async (fieldValue, validation, options) => {
  const { value, message, func } = validation;

  if (value) {
    const { getFieldBydId, objectType, pkObjectType, fieldName, globalModel, mode, fieldType, pk } =
      options;
    const response = {};

    const currentMode = getCurrentMode(mode);

    const result = await getFieldBydId({
      currentMode,
      fieldName,
      fieldType,
      fieldValue,
      func,
      globalModel,
      objectType,
      pk,
      pkObjectType,
    });

    switch (currentMode) {
      case FORM_MODE.INSERT:
        response.canUse = result?.length !== 0 ? message : undefined;
        break;
      case FORM_MODE.UPDATE:
        response.canUse = result?.length === 0 ? message : undefined;
        break;
      default:
        response.canUse = true;
        break;
    }
  }
};

module.exports = { uniqueBack };
